import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SharedModule } from '../../../../modules/shared/shared.module';
import { CheckboxComponent } from '../../../common/checkbox/checkbox.component';
import { MasterService } from '../../../../services/masters-service';
import { LoadingService } from '../../../../services/loading.service';
import { ToasterService } from '../../../../services/toaster.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToggleComponent } from '../../../common/toggle/toggle.component';

@Component({
  selector: 'app-manage-vehicle',
  standalone: true,
  imports: [SharedModule, CheckboxComponent, ToggleComponent],
  templateUrl: './manage-vehicle.component.html',
  styleUrl: './manage-vehicle.component.scss',
})
export class ManageVehicleComponent {
  @Input() vehicleId: string = '';
  @Input() mode?: 'edit' | 'view';
  @Output() onSuccessfulSave = new EventEmitter<void>();

  vehicleForm!: FormGroup;
  readOnlyMode = true;
  masterEditingEnabled = false;

  constructor(
    private masterService: MasterService,
    private loadingService: LoadingService,
    private toasterService: ToasterService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.vehicleForm = this.initForm();
  }

  ngOnInit() {
    console.log('vehicleId', this.vehicleId);
    

    if (this.vehicleId) {
      this.masterEditingEnabled = this.mode === 'edit';
      this.readOnlyMode = this.mode === 'view';
      this.loadVehicleData();

      if (this.readOnlyMode) {
        this.vehicleForm.disable();
      }
    } else {
      this.readOnlyMode = false;
      this.masterEditingEnabled = false;
    }
 
  }

  private initForm(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],
      description: [null],
      active: true,
    });
  }

  closeRightPanel!: (params?: any) => void;

  close(params?: any) {
    if (this.closeRightPanel) {
      this.closeRightPanel(params);
    }
  }

  onSubmit(): void {
    this.vehicleForm?.markAllAsTouched();
    if (!this.vehicleForm.valid) return;
    const vehicleData = this.vehicleForm.value;
    const action$ = this.vehicleId
      ? this.masterService.updateVehicleMaster(this.vehicleId, vehicleData)
      : this.masterService.addVehicle(vehicleData);

    action$.subscribe({
      next: () => {
        const message = this.vehicleId
          ? `Vehicle ${vehicleData.name} has been updated!`
          : `Vehicle ${vehicleData.name} has been added!`;
        this.toasterService.success(message);
        this.loadingService.hide();
        this.onSuccessfulSave.emit();
      },
      error: (err) => {
        this.toasterService.error(err.error.errorDesc || 'An error occurred');
        console.error('Error submitting form:', err);
        this.loadingService.hide();
      },
    });
  }

  private loadVehicleData(): void {
    this.loadingService.show();
    this.masterService.getVehicle(this.vehicleId).subscribe({
      next: (res: any) => {
        const vehicleData: any = res.data;
        this.patchForm(vehicleData);
        this.loadingService.hide();
      },
      error: (err) => {
        console.error('Error loading vehicle data:', err);
        this.toasterService.error('Failed to load vehicle data');
        this.loadingService.hide();
      },
    });
  }

  private patchForm(vehicle: any): void {
    this.vehicleForm.patchValue(vehicle);
  }
}